import { call, put, select } from 'redux-saga/effects';
import {
  getProductEvaluateRules,
  getProductsRecom,
} from '@bit/gerenciatd.adabyron-cloud.catalogue';
import { getSellingTypesByProductId } from '@bit/gerenciatd.adabyron.cqv2';
import { getProductEvaluateRulesDistriFusion } from '@bit/gerenciatd.adabyron-cloud.customizer';
import { getMyProducts as getMyProductsAdabayron } from '@bit/gerenciatd.adabyron.product';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { ACTION_SUBTYPES } from '@bit/gerenciatd.telcovid.catalog-constants';
import { getProductOffering } from '@bit/gerenciatd.adabyron.catalog';

import {
  tratarParqueTELCO,
  convertirObjetoEnviarParque,
  getGroupByProductAlias,
  checkClientHaveDemand,
  getSelectedProduct,
  getPrincipalLineProductIdFromMyProducts,
  getFusionProductIdFromMyProducts,
} from '../utils/productUtils';
import { actions as fusionActions } from '../reducers/fusion';
import {
  normalizeRecom,
  normalizePrevention,
  normalizeChannels,
  getCatalogueProductOfferingNormalizer,
  getUUID,
} from './normalizers/fusion';
import {
  filterProducts,
  selectProduct,
} from '../components/DistriFusionContainer/FusionUtils';
import { actions as legadoActions } from '../reducers/legado';
import { handleSagaError } from './index';
import { USER_TYPE } from '../constants/constants';
import {
  getDeviceInfoFromHiredProduct,
  getAditionalDeviceInfo,
} from '../components/ProductModal/Configurator/Utils';

const mainSetup = require('../../config/mainSetup');

const contextStore = (state) => state.context.data;
const productsStore = (state) => state.fusion.products;
const filtersStore = (state) => state.filters.filters;
const productState = (state) => state.fusion.productsState;
const getHiredProductsR2rpriceFromStore = (state) => state.fusion.hiredProductR2rPrice;
const getHiredProductsR2rpriceAditionalFromStore = (state) => state.fusion.hiredProductR2rPriceAditional;

const { projectId, dos } = mainSetup;

const idFront = 'TC';

const STORAGE_PRODUCT_LOCATION = {
  INCLUDED_PRODUCT: 'terminal-incluido',
  ADITIONAL_PRODUCT: 'terminal-adicional',
};

const CATALOG_SECTIONS = {
  VERTICALS: {
    ID: '387',
    SUB_SECTIONS: {
      COMMUNICATIONS: '388',
      SECURITY: '389',
      HEALTH: '390',
      FINANCES: '391',
    },
  },
};

const ARRAY_SUBSECCION = [
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS,
];

/**
 * Orquesta las peticiones de customizer a través de adabyron para guardar en redux
 * los subproducts de un producto
 * y lo guarda en redux
 * @param {object} dataToAdabyron
 * @return {undefined}
 */
export function* getSubproductsFromProducts(dataToAdabyron) {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'getSubproductsFromProducts',
    context,
    filePath: 'sagas/Fusion',
  });
  try {
    const { params } = dataToAdabyron;
    const { recomCode, promoCode } = params;
    const data = {
      productList: [
        {
          hiredSubProducts: [],
          parqueSearch: false,
          productType: 'FIBRA',
          viewType: 'none',
          idType: 't',
          product: recomCode,
          infoRulesMap: {
            var1: promoCode,
          },
        },
      ],
    };
    const argsToAdabyron = [data, context];
    let response = '';
    try {
      response = yield call(getProductEvaluateRules, ...argsToAdabyron);
    } catch (wsError) {
      let info = '';
      if (data && data.productList && data.productList.infoRulesMap) {
        const { product, infoRulesMap } = data;
        const { var1 } = infoRulesMap;
        info = `recomCode:${product}--promoCode:${var1}`;
      }
      sonda.warningMessage({ info, error: wsError });
      yield put(fusionActions.getSubproductsFromProductsFailure());
      // Romper la ejecución para que la comprobación posterior del response sea valida
      // Ya que el servicio puede funcionar pero devolver una respuesta vacia
      return;
    }
    if (response) {
      response = normalizeChannels(response[0].subProducts[0]);
      yield put(fusionActions.getSubproductsFromProductsSuccess(response));
    } else {
      yield put(fusionActions.getSubproductsFromProductsFailure());
    }
  } catch (error) {
    sonda.errorMessage({ error });
    yield put(fusionActions.getSubproductsFromProductsFailure());
  }
}

/**
 * Orquesta las peticiones de customizer para guardar en redux
 *  todos los productos a mostrar en la distributiva de fusión
 * @param {object} params
 * @return {undefined}
 */
// TO DO: revisar el quitado de params

export function* getAllProducts() {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'getAllProducts',
    context,
    filePath: 'sagas/Fusion',
  });

  try {
    if (productState !== 'FETCHING') {
      const data = {
        viewType: 'min',
        prodContCode: '',
        faqs: true,
        product: undefined,
        subproducts: true,
      };

      context.contextURL = context.contextURL.replace('/landing', '');
      const paramsRecom = [context, data];
      let response = '';

      try {
        response = yield call(getProductsRecom, ...paramsRecom);
      } catch (wsError) {
        sonda.errorMessage({ error: wsError });
        const reducerFailureAction = fusionActions.getAllProductsFailure();
        yield handleSagaError(reducerFailureAction);
        // Romper la ejecución para que la comprobación posterior del response sea valida
        // Ya que el servicio puede funcionar pero devolver una respuesta vacia
        return;
      }

      if (response) {
        yield put(
          fusionActions.getAllProductsSuccess(
            normalizeRecom({ data: response, context, isOldCatalog: false })
          )
        );
      } else {
        const reducerFailureAction = fusionActions.getAllProductsFailure();
        yield handleSagaError(reducerFailureAction);
      }
    }
  } catch (error) {
    sonda.errorMessage({ error });
    const reducerFailureAction = fusionActions.getAllProductsFailure();
    yield handleSagaError(reducerFailureAction);
  }
}

/**
 * Orquesta las peticiones para guardar en redux el grupo del producto seleccionado
 * en el productItem
 * @param {object} info
 * @return {undefined}
 */
export function* selectProductSaga(info) {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'selectProductSaga',
    context,
    filePath: 'sagas/Fusion',
  });
  if (info && info.payload) {
    const products = yield select(productsStore);
    const group = selectProduct(
      info.payload.data,
      info.payload.groupp,
      info.payload.selectedProduct,
      info.payload.selectorOption
    );
    // Busco en products cuál es el grupo que tengo que sustituir por el resultado del select.
    const result = products;
    let affectedGroup = null;
    if (products && products.allProducts) {
      Object.keys(products.allProducts).forEach((groupIterator) => {
        const groupObject = products.allProducts[groupIterator];
        if (groupObject) {
          Object.keys(groupObject).forEach((productKey) => {
            const productObject = groupObject[productKey];
            if (
              productObject.product
              && productObject.product.alias
                === info.payload.selectedProduct.product.alias
            ) {
              affectedGroup = groupIterator;
            }
          });
        }
      });
    }
    result.allProducts[affectedGroup] = group;
    yield put(fusionActions.setAllProducts(result));
  } else {
    sonda.errorMessage({ info: 'info no existe' });
  }
}

/**
 * Retorna el parque normalizado cuando es un cliente telco
 * @returns {object|null} object: el parque normalizado| null: no consigue obtener el parque
 */
function* getParqueTelco() {
  const data = { catalogSubSections: ARRAY_SUBSECCION };
  const context = yield select(contextStore);

  const sonda = new Sonda({
    processName: 'getParqueTelco',
    context,
    filePath: 'sagas/Fusion',
  });
  const sondaFinding = new Sonda({
    processName: 'INVESTIGACION_getParqueTelco',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  const args = [data, context, idFront];
  let response = '';
  try {
    response = yield call(getMyProductsAdabayron, ...args);
  } catch (wsError) {
    sonda.errorMessage({ error: wsError });
    const parqueIncompatible = {
      event: 'cms-page',
      'event-type': 'parque-login',
      'prod-cont-code': 'no-recuperado',
    };
    if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
      window.nookInfoExchange.sendMessage('Metrics', parqueIncompatible);
    }
    sondaFinding.warningMessage({
      info: `INVESTIGACION ha fallado el servicio de parque 
      error:   ${JSON.stringify({
    msg: wsError && wsError.message ? wsError.message : '',
  })}
  `,
    });

    yield call(this.manageMyProductsData, {
      incompatible: true,
    });
    yield put(fusionActions.getMyHiredProductFailure());

    return null;
  }
  if (response) {
    yield put(
      fusionActions.getClientDemandsByProductIdBegins({
        productLineId: getPrincipalLineProductIdFromMyProducts(response),
        productFusionId: getFusionProductIdFromMyProducts(response),
        includedDevice: getDeviceInfoFromHiredProduct(response),
      })
    );

    yield put(fusionActions.getMyHiredProductSuccess(response));
    // lanzar los cambios desde aqui

    const sonda2 = new Sonda({
      processName: 'getParqueTelcoTerminales',
      context,
      filePath: 'sagas/Fusion',
    });
    try {
      const deviceInfoIncluded = getDeviceInfoFromHiredProduct(response);
      const aditionalDevices = getAditionalDeviceInfo(response);
      if (
        deviceInfoIncluded
        && Array.isArray(deviceInfoIncluded)
        && deviceInfoIncluded.length > 0
        && deviceInfoIncluded[0]
        && deviceInfoIncluded[0].productId
      ) {
        yield put(
          fusionActions.getMyHiredProductR2rPriceBegins({
            idPO: deviceInfoIncluded[0].productId,
            myHiredProduct: response,
            locationStorage: 'terminal-incluido',
          })
        );
      }

      if (
        aditionalDevices
        && Array.isArray(aditionalDevices)
        && aditionalDevices.length > 0
        && aditionalDevices[0]
        && aditionalDevices[0].productId
      ) {
        yield put(
          fusionActions.getMyHiredProductR2rPriceAditionalBegins({
            idPO: aditionalDevices[0].productId,
            myHiredProduct: response,
            locationStorage: 'terminal-adicional',
          })
        );
      }
    } catch (wsError) {
      sonda2.errorMessage({ error: wsError });
    }

    return tratarParqueTELCO(response);
  }
}

/**
 * Orquesta las peticiones para guardar en redux el producto del parque del cliente
 *  y lo normaliza con los produtos de la distri de fusion.
 * @param {object,string,boolean} (productInfo, aliasType, incompatible)
 * @return {undefined|null} null cuando el usuario es incompatible y undefined
 *                          cuando se corta la ejecución
 * 1- Llamamos al evaluateRules para obtener el producto contratado
 * 2- Realizamos la llamada al endopint de customizer enviandole el producto contratado
 * 3- Dependiendo del tipo de producto contratado
 *  3.1) ('vintage': producto no catalogado)
 *        -Marcamos en redux que es un producto vintage
 *  3.2) si el producto es de antiguo catalogo:
 *        -normalizamos y subirmos a redux el resultado marando como antiguo portfolio
 *  3.3) Si el producto pertenece al portfolio actual
 *        -normalizamos y subirmos a redux el resultado
 */
export function* manageMyProductsData({
  productInfo,
  aliasType,
  incompatible,
}) {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'manageMyProductsData',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  const sondaFinding = new Sonda({
    processName: 'INVESTIGACION',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  const sondaTestBadRequest = new Sonda({
    processName: 'INVESTIGACION_Error_peroParquerecuperado',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  let prodContCodeBuild = null;
  if (productInfo) {
    prodContCodeBuild = JSON.stringify(
      convertirObjetoEnviarParque(
        productInfo.tipoNetflix,
        productInfo.codFusionParque,
        productInfo.codPromoCliente,
        context.userType
      )
    );
  }
  const dataRecom = {
    viewType: 'min',
    faqs: true,
    subproducts: true,
    prodContCode: prodContCodeBuild || '',
    product: undefined,
  };

  try {
    context.contextURL = window.location.href;

    if (incompatible) {
      yield put(fusionActions.getHiredProductsSuccess('none'));
      const paramsRecom = [context, dataRecom];
      let response = '';
      try {
        response = yield call(getProductsRecom, ...paramsRecom);
      } catch (wsError) {
        sonda.severalMessage({ error: wsError });
        const reducerFailureAction = fusionActions.getAllProductsFailure();
        yield handleSagaError(reducerFailureAction);
        // Romper la ejecución para que la comprobación posterior del response sea valida
        // Ya que el servicio puede funcionar pero devolver una respuesta vacia
        return null;
      }
      response = normalizeRecom({
        data: response,
        context,
        isOldCatalog: false,
      });
      yield put(fusionActions.getAllProductsSuccess(response));

      return null;
    }
    const data = {
      viewType: 'min',
      faqs: 'true',
      subproducts: 'true',
      products: [
        {
          prodCode: productInfo.codFusionParque,
          promoCode: productInfo.codPromoCliente,
          recomType: 'fusion',
          aliasType,
        },
      ],
    };

    const params = [data, context];
    let response2 = '';
    try {
      response2 = yield call(getProductEvaluateRulesDistriFusion, ...params);
    } catch (wsError) {
      sonda.warningMessage({ error: wsError });
    }

    const paramsRecom = [context, dataRecom];
    let response = '';
    try {
      response = yield call(getProductsRecom, ...paramsRecom);
    } catch (wsError) {
      sonda.errorMessage({ error: wsError });
      const reducerFailureAction = fusionActions.getAllProductsFailure();
      yield handleSagaError(reducerFailureAction);
      // Romper la ejecución para que la comprobación posterior del response sea valida
      // Ya que el servicio puede funcionar pero devolver una respuesta vacia
      return null;
    }
    response = normalizeRecom({
      data: response,
      context,
      isOldCatalog: false,
    });

    if (!response2 || !Array.isArray(response2) || response2.length === 0) {
      dataRecom.prodContCode = JSON.stringify(
        convertirObjetoEnviarParque(
          productInfo.tipoNetflix,
          productInfo.codFusionParque,
          productInfo.codPromoCliente,
          context.userType
        )
      );
      const parqueData = {
        event: 'cms-page',
        'event-type': 'parque-login',
        'prod-cont-code': dataRecom.prodContCode,
      };
      if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
        window.nookInfoExchange.sendMessage('Metrics', parqueData);
      }
      yield put(fusionActions.getHiredProductsSuccess('vintage'));
      yield put(fusionActions.getAllProductsSuccess(response));
    } else {
      // yield put(fusionActions.getAllProductsBegins());

      const auxAllProducts = JSON.parse(JSON.stringify(response.allProducts));

      const { groupProductsKey, content } = getGroupByProductAlias(
        response2[0].product.alias,
        auxAllProducts
      );

      /* Cuando el producto contratado pertenece a portfolio antiguo */
      if (!groupProductsKey || groupProductsKey === 'undefined') {
        const isOldCatalog = true;
        const groupProductsOldCatalogKey = 'fusion catalogo antiguo';

        const objToNormalize = {
          allProducts: {
            [groupProductsOldCatalogKey]: {
              [response2[0].product.alias]: response2[0],
            },
          },
        };
        const oldCatalogProductsNormalized = normalizeRecom({
          data: objToNormalize,
          isOldCatalog,
          context,
        });

        const groupProductsOldCatalog = oldCatalogProductsNormalized.allProducts[groupProductsOldCatalogKey];
        const oldCatalogProductSelected = getSelectedProduct(
          groupProductsOldCatalog
        );

        yield put(
          fusionActions.getHiredProductsSuccess(groupProductsOldCatalog)
        );
        yield put(
          fusionActions.setProductHiredUnique(oldCatalogProductSelected)
        );
        yield put(fusionActions.setProductIsOldCatalogue(true));

        // mandamos el evento parque login de los
        dataRecom.prodContCode = JSON.stringify(
          convertirObjetoEnviarParque(
            productInfo.tipoNetflix,
            productInfo.codFusionParque,
            productInfo.codPromoCliente,
            context.userType
          )
        );
        const parqueData = {
          event: 'cms-page',
          'event-type': 'parque-login',
          'prod-cont-code': dataRecom.prodContCode,
        };
        if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
          window.nookInfoExchange.sendMessage('Metrics', parqueData);
        }
        /* Cuando el producto contratado pertenece al nuevo portfolio */
      } else {
        // delete response.allProducts[groupProductsKey];

        yield put(fusionActions.setGroupOfProductsHired(groupProductsKey));

        const productHiredNormalized = [];
        productHiredNormalized.allProducts = [];
        productHiredNormalized.allProducts[response2[0].product.alias] = [];
        productHiredNormalized.allProducts[response2[0].product.alias][
          response2[0].product.alias
        ] = response2[0];

        normalizeRecom({
          data: productHiredNormalized,
          context,
          isOldCatalog: false,
        });
        let contentAlias = '';
        Object.keys(content).find((element) => {
          if (typeof content[element].product !== 'undefined') {
            if (content[element].product.alias === response2[0].product.alias) {
              contentAlias = element;
              content[element] = productHiredNormalized.allProducts[response2[0].product.alias][
                response2[0].product.alias
              ];
            }
          }
        });

        const contentKeys = Object.keys(content);
        contentKeys.forEach((key) => {
          const productObject = content[key];
          if (typeof productObject === 'object' && key !== 'selector') {
            content[key].selected = false;
          }
        });
        content[contentAlias].selected = true;
        yield put(fusionActions.getHiredProductsSuccess(content));

        const productSelected = getSelectedProduct(content);
        yield put(fusionActions.setProductHiredUnique(productSelected));

        let prodPrice = '';
        let promotedProdPrice = '';
        if (productSelected) {
          const { dataMap } = productSelected;
          const { pvp, pvpTachado } = dataMap;

          prodPrice = pvpTachado || pvp;
          promotedProdPrice = pvpTachado ? pvp : pvpTachado;
        }

        // mandamos el evento parque login
        dataRecom.prodContCode = JSON.stringify(
          convertirObjetoEnviarParque(
            productInfo.tipoNetflix,
            productInfo.codFusionParque,
            productInfo.codPromoCliente,
            context.userType,
            prodPrice,
            promotedProdPrice
          )
        );
        const parqueData = {
          event: 'cms-page',
          'event-type': 'parque-login',
          'prod-cont-code': dataRecom.prodContCode,
        };
        if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
          window.nookInfoExchange.sendMessage('Metrics', parqueData);
        }
      }
      yield put(fusionActions.getAllProductsSuccess(response));
    }
  } catch (error) {
    if (productInfo) {
      // console.log('enviarparque mas marca de que algo falla para analizarlo');
      dataRecom.prodContCode = JSON.stringify(
        convertirObjetoEnviarParque(
          productInfo.tipoNetflix ? productInfo.codFusionParque : '',
          productInfo.codFusionParque ? productInfo.codFusionParque : '',
          productInfo.codPromoCliente ? productInfo.codPromoCliente : '',
          context.userType
        )
      );
      const parqueData = {
        event: 'cms-page',
        'event-type': 'parque-login',
        'prod-cont-code': dataRecom.prodContCode,
      };
      if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
        window.nookInfoExchange.sendMessage('Metrics', parqueData);
      }
      // MANDAR SONDA CON LOS PARQUES RAROS PARA ANALIZAR
      sonda.warningMessage({
        info: `CASO-PARTICULAR: productInfo:${JSON.stringify(productInfo)}`,
        error,
      });
      sondaTestBadRequest.warningMessage({
        info: `CASO-PARTICULAR_OK_peroIncompatible: productInfo:${JSON.stringify(
          {
            productInfo,
          }
        )} aliasType: ${JSON.stringify({
          aliasType,
        })} incompatible:${JSON.stringify({ incompatible })}`,
      });
    } else {
      sonda.errorMessage({ error });

      yield put(fusionActions.getHiredProductsSuccess('none'));

      const parqueIncompatible = {
        event: 'cms-page',
        'event-type': 'parque-login',
        'prod-cont-code': 'no-recuperado',
      };
      if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
        window.nookInfoExchange.sendMessage('Metrics', parqueIncompatible);
      }
      sondaFinding.warningMessage({
        info: `CASO-PARTICULAR: productInfo:${JSON.stringify({
          productInfo,
        })} aliasType: ${JSON.stringify({
          aliasType,
        })} incompatible:${JSON.stringify({ incompatible })}
        userType:${JSON.stringify({ userType: context.userType })}
        error:${JSON.stringify({
    msg: error && error.message ? error.message : '',
  })}`,
      });
      const paramsRecom = [context, dataRecom];
      let response = '';
      try {
        response = yield call(getProductsRecom, ...paramsRecom);
      } catch (wsError) {
        sonda.severalMessage({ error: wsError });
        const reducerFailureAction = fusionActions.getAllProductsFailure();
        yield handleSagaError(reducerFailureAction);
        // Romper la ejecución para que la comprobación posterior del response sea valida
        // Ya que el servicio puede funcionar pero devolver una respuesta vacia
        return null;
      }
      response = normalizeRecom({
        data: response,
        context,
        isOldCatalog: false,
      });
      yield put(fusionActions.getAllProductsSuccess(response));
    }
  }
  return null;
}

/**
 * Orquesta las peticiones para guardar en redux el filtrado de los productos.
 * @return {undefined}
 */
export function* filter() {
  const products = yield select(productsStore);
  const filters = yield select(filtersStore);
  if (filters) {
    const { selectedFilters } = filters;
    const result = filterProducts(products, selectedFilters);
    yield put(fusionActions.setAllProducts(result));
  }
}

/**
 * Orquesta las peticiones para guardar en redux el parque segun el tipo de usuario
 * administrado context en caso de fallo al recoger el parque, tratamos el error
 * y llamamos a customizer para pintar el Allproducts
 * @return {undefined|null} null cuando el usuario es incompatible
 *                          y undefined cuando se corta la ejecución
 */
export function* getMyProducts() {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'getMyProducts',
    context,
    filePath: 'sagas/Fusion',
  });
  const sondaFinding = new Sonda({
    processName: 'INVESTIGACION_getMyProducts',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  let productInfo = [];
  let aliasType = '';
  try {
    if (productState !== 'FETCHING') {
      if (
        context.userType === USER_TYPE.TELCO
        || context.userType === USER_TYPE.GESTOR
      ) {
        productInfo = yield call(getParqueTelco);
        aliasType = 'po';
        yield call(manageMyProductsData, { productInfo, aliasType });
      } else if (context.userType === 'Legado') {
        yield put(legadoActions.launchIframeCCLIListener());
        aliasType = 'ci';
      }
    }
  } catch (error) {
    sonda.errorMessage({ error });
    const dataRecom = {
      viewType: 'min',
      faqs: true,
      subproducts: true,
      prodContCode: '',
      product: undefined,
    };
    yield put(fusionActions.getHiredProductsSuccess('none'));

    const parqueIncompatible = {
      event: 'cms-page',
      'event-type': 'parque-login',
      'prod-cont-code': 'no-recuperado',
    };
    if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
      window.nookInfoExchange.sendMessage('Metrics', parqueIncompatible);
    }
    sondaFinding.warningMessage({
      info: `CASO-PARTICULAR: productInfo:${JSON.stringify({
        productInfo,
      })} aliasType: ${JSON.stringify({
        aliasType,
      })} userType:${JSON.stringify({ userType: context.userType })} 
      error:${JSON.stringify({
    msg: error && error.message ? error.message : '',
  })} 
      `,
    });

    const paramsRecom = [context, dataRecom];
    let response = '';
    try {
      response = yield call(getProductsRecom, ...paramsRecom);
    } catch (wsError) {
      sonda.severalMessage({ error: wsError });
      const reducerFailureAction = fusionActions.getAllProductsFailure();
      yield handleSagaError(reducerFailureAction);
      // Romper la ejecución para que la comprobación posterior del response sea valida
      // Ya que el servicio puede funcionar pero devolver una respuesta vacia
      return null;
    }
    if (response) {
      response = normalizeRecom({
        data: response,
        isOldCatalog: false,
        context,
      });
      yield put(fusionActions.getAllProductsSuccess(response));
      yield put(fusionActions.getHiredProductsFailure());
    }
  }
  return null;
}

/**
 * Funcion para obtener el producto de prevencion para recomendar al cliente
 * en el modal de retencion llamando al evaluateRules de custo
 * @return {undefined|null} Undefined cuando se corta la ejecución
 */
export function* getPreventProduct({ prodCode, promoCode }) {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'getPreventProduct',
    context,
    filePath: `${projectId}-SAGA:Fusion`,
  });
  if (!prodCode && !promoCode) {
    sonda.warningMessage({ info: 'EMPTY PARAMS' });
    yield put(fusionActions.getPreventionProductFailure());
  }
  try {
    const aliasType = 't';
    const data = {
      viewType: 'min',
      faqs: 'true',
      subproducts: 'true',
      products: [
        {
          prodCode,
          promoCode,
          recomType: 'fusion',
          aliasType,
        },
      ],
    };

    const paramsToAdaByron = [data, context];
    const response2 = yield call(
      getProductEvaluateRulesDistriFusion,
      ...paramsToAdaByron
    );
    if (response2 && Array.isArray(response2) && response2.length > 0) {
      // const aliasProduct=response2[0].product.alias;
      const adaptedData = {
        additionalRecommendation: [],
        allProducts: { 'fusion prevencion': { aliasProduct: response2[0] } },
        infoRecom: {},
        recommendationTuring: [],
      };

      yield put(
        fusionActions.getPreventionProductSuccess(
          normalizePrevention({
            data: adaptedData,
            isOldCataloge: false,
            context,
          })
        )
      );
    } else {
      sonda.warningMessage({ info: 'EMPTY RESPONSE' });
      yield put(fusionActions.getPreventionProductFailure());
    }
  } catch (error) {
    console.log(error);
    sonda.severalMessage({ error });
    yield put(fusionActions.getPreventionProductFailure());
  }
}

/**
 * Obtiene las demandas del cliente a través del product offering del producto
 * @param {object} (parametros enviados desde la llamada del beggins)
 * @return {undefined} no retorna nada, guarda en redux
 */
export function* getClientDemandsByProductId(params) {
  try {
    const { productLineId, productFusionId, includedDevice } = params;
    let responseLines = null;
    const context = yield select(contextStore);
    let data = { productId: productLineId };
    responseLines = yield call(
      getSellingTypesByProductId,
      data,
      context,
      idFront
    );
    const checkClienteInitialDemand = checkClientHaveDemand(
      responseLines,
      ACTION_SUBTYPES.TERMINAL_R2R
    );
    let hasClientAlreadyIncludedDevice = false;
    if (
      includedDevice
      && Array.isArray(includedDevice)
      && includedDevice.length > 0
      && !checkClienteInitialDemand
    ) {
      hasClientAlreadyIncludedDevice = true;
    }
    yield put(
      fusionActions.setClientAlreadyDevice(hasClientAlreadyIncludedDevice)
    );

    let responseFusion = null;
    data = { productId: productFusionId };
    responseFusion = yield call(
      getSellingTypesByProductId,
      data,
      context,
      idFront
    );
    const checkCanObtainSecondDevice = checkClientHaveDemand(
      responseFusion,
      ACTION_SUBTYPES.TERMINAL_R2R_ADDITIONAL
    );
    yield put(
      fusionActions.setCanObtainSecondDevice(checkCanObtainSecondDevice)
    );

    yield put(
      fusionActions.getClientDemandsByProductIdSuccess(
        responseLines,
        responseFusion
      )
    );
  } catch (error) {
    yield put(fusionActions.getClientDemandsByProductIdFailure(error));
  }
}

/**
 * Funcion que obtiene el producto contratado a través de un product idPO.
 * @param {string/object/object} (idPO: id del producto contratado , context: contexto
 * de la app, innerProduct: producto interno contratado)
 * @return {undefined} no retorna nada, guarda en redux
 */
export function* getMyHiredProductByParams({ idPO, context, innerProduct }) {
  const product = yield call(getProductOffering, { idPO }, context, idFront);
  let productOfferingNormalized = null;
  if (product) {
    productOfferingNormalized = getCatalogueProductOfferingNormalizer(
      innerProduct,
      product
    );
  }
  return productOfferingNormalized;
}

/**
 * Guarda los productos en el redux correspondiente el producto, si es adicional o incluido.
 * @param {object} (parametros enviados desde la llamada del beggins)
 * @return {undefined} no retorna nada, guarda en redux
 */
export function* saveProductIncludedOrAditional({ params }) {
  const context = yield select(contextStore);
  try {
    const { idPO, locationStorage, myHiredProduct: innerProduct } = params;
    let productOfferingNormalized = null;

    // obtener el producto en funcion de si ya lo tiene la liberia
    if (STORAGE_PRODUCT_LOCATION.INCLUDED_PRODUCT === locationStorage) {
      const currentHiredProductR2rPrice = yield select(
        getHiredProductsR2rpriceFromStore
      );
      if (
        idPO
        && currentHiredProductR2rPrice
        && !currentHiredProductR2rPrice[idPO]
      ) {
        productOfferingNormalized = yield call(getMyHiredProductByParams, {
          idPO,
          context,
          innerProduct,
        });
      }
    } else if (STORAGE_PRODUCT_LOCATION.ADITIONAL_PRODUCT === locationStorage) {
      const currentHiredProductR2rPriceAditional = yield select(
        getHiredProductsR2rpriceAditionalFromStore
      );
      if (
        idPO
        && currentHiredProductR2rPriceAditional
        && !currentHiredProductR2rPriceAditional[idPO]
      ) {
        productOfferingNormalized = yield call(getMyHiredProductByParams, {
          idPO,
          context,
          innerProduct,
        });
      }
    }

    // guardar en el redux dentro del cajon del includido
    if (STORAGE_PRODUCT_LOCATION.INCLUDED_PRODUCT === locationStorage) {
      if (productOfferingNormalized) {
        yield put(
          fusionActions.getMyHiredProductR2rPriceSuccess(
            productOfferingNormalized
          )
        );
      }
      // guardar en el redux dentro del cajon del adicional
    } else if (STORAGE_PRODUCT_LOCATION.ADITIONAL_PRODUCT === locationStorage) {
      if (productOfferingNormalized) {
        yield put(
          fusionActions.getMyHiredProductR2rPriceAditionalSuccess(
            productOfferingNormalized
          )
        );
      }
    }
  } catch (err) {
    const sonda = new Sonda({
      processName: 'saveProductIncludedOrAditional',
      context,
      filePath: `${projectId}-SAGA:Fusion`,
    });
    sonda.warningMessage({
      info: 'Error al recuperar el precio restante del teminal al mes',
      error: err,
    });

    if (
      params
      && params.locationStorage
      && STORAGE_PRODUCT_LOCATION.INCLUDED_PRODUCT === params.locationStorage
    ) {
      fusionActions.getMyHiredProductR2rPriceFailure();
    } else if (
      params
      && params.locationStorage
      && STORAGE_PRODUCT_LOCATION.ADITIONAL_PRODUCT === params.locationStorage
    ) {
      fusionActions.getMyHiredProductR2rPriceAditionalFailure();
    }
  }
}
